import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LoginPage } from "@teuteuf-games/login-page";
import UserContext from "../../UserProvider";
import { clearCookie } from "../../services/cookies";
import { initialState } from "../../data/userDetailsInitial";

export const Account = () => {
  const { userDetails } = useContext(UserContext);

  return (
    <>
      <div className="px-4 md:px-0">
        <div className="mb-4 mt-4">
          <Link to="/">
            <span className="text-blue-500 hover:text-blue-400">
              &#8592; Back
            </span>
          </Link>
        </div>
        {userDetails.loggedIn ? <AccountDashboard /> : <SignIn />}
        <div className="text-start py-5 text-xs">
          <p>
            You can change your privacy settings by clicking the following
            button:{" "}
            <button
              className="underline cursor-pointer"
              onClick={() => window.adconsent && window.adconsent("showGUI")}
            >
              Manage Consent
            </button>
          </p>
        </div>
      </div>
    </>
  );
};

export const SignIn = () => {
  const hostname = window?.location.hostname;
  const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
  const authServerUrl = isLocalhost
    ? "http://localhost:3000"
    : hostname.includes("staging")
      ? "https://staging-auth.teuteuf.fr"
      : "https://auth.teuteuf.fr";
  const referer = isLocalhost ? "localhost-emovi" : "emovi";

  return (
    <div className="flex justify-center mt-4">
      <LoginPage authServerUrl={authServerUrl} referer={referer} />
    </div>
  );
};

export const AccountDashboard = () => {
  const { userDetails, setUserDetails } = useContext(UserContext);
  const navigate = useNavigate();

  const handleSignOut = () => {
    clearCookie("isLoggedIn");
    clearCookie("jwt");
    setUserDetails(initialState);
    localStorage.removeItem("emovi-user");
    navigate("/");
  };

  return (
    <>
      <h2 className="text-xl font-bold">Your account</h2>
      <div>
        <p className="mt-3">Hi {userDetails.firstName} 👋</p>
        <p className="mt-2">
          We now store your stats after each game. This not only safeguards your
          progress but also enables seamless gameplay across multiple devices.{" "}
          <a
            href="https://account.teuteuf.fr"
            className="text-blue-500 hover:text-blue-400 cursor-pointer"
          >
            Learn more
          </a>
          .
        </p>

        <div className="bg-amber-100 shadow-md rounded-md p-3 mt-4 mb-6 text-black">
          <h5 className="font-bold">Want to play previous games?</h5>
          <p className="mt-2">
            Want to play previous games of Emovi? All the way back to the very
            first game?
          </p>
          <div className="flex gap-1 flex-col md:flex-row">
            <button
              onClick={() => navigate("/archive")}
              className="border bg-neutral-100 border-black rounded-md text-black font-bold py-2 px-4 shadow-md mt-2"
            >
              Play the archive
            </button>
            <button
              onClick={() => {
                navigate("/replay");
              }}
              className="border bg-neutral-100 border-black rounded-md text-black font-bold py-2 px-4 shadow-md mt-2"
            >
              Replay today's game
            </button>
          </div>
        </div>

        <div className="flex gap-2 mt-4 items-center">
          <button
            onClick={handleSignOut}
            className="bg-blue-600 hover:bg-blue-400 text-white font-bold py-2 px-4 rounded"
          >
            Sign out
          </button>
          <a
            href="https://account.teuteuf.fr"
            className="border border-slate-400 text-black font-bold py-2 px-4 rounded"
          >
            Manage account
          </a>
        </div>
      </div>
    </>
  );
};
